// extracted by mini-css-extract-plugin
module.exports = {"icon":"OutlineButton_icon__1HKx-","container":"OutlineButton_container__S60DX","wrapper":"OutlineButton_wrapper__1sKjG","disabled":"OutlineButton_disabled__k3u2Z"};